<template>
  <div id="app">
    <!-- Credit Scope 品牌流动波纹与光晕装饰层 -->
    <div class="brand-ambient-glow glow-top"></div>
    <div class="brand-ambient-glow glow-middle"></div>
    <div class="brand-ambient-glow glow-bottom"></div>
    <div class="brand-waves-decor"></div>
    <div class="brand-ambient-rings"></div>
    
    <!-- 路由主视口 -->
    <div class="app-main-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style lang="scss">
@import "@/assets/custom_theme.scss";

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #FFFFFF;
  background-color: #248B77;
  background-image: 
    radial-gradient(ellipse 90% 50% at 50% -5%, rgba(46, 178, 154, 0.45) 0%, transparent 75%),
    radial-gradient(ellipse 80% 50% at 50% 105%, rgba(22, 107, 90, 0.6) 0%, transparent 70%),
    linear-gradient(180deg, #289682 0%, #228572 45%, #186B5A 100%);
  min-height: 100vh;
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  overflow-x: hidden;
  box-shadow: 0 0 60px rgba(10, 48, 42, 0.6);
}

/* 顶部、中部与底部环境光晕 */
.brand-ambient-glow {
  position: fixed;
  pointer-events: none;
  z-index: 0;
  border-radius: 50%;
  filter: blur(50px);
}

.glow-top {
  top: -100px;
  left: 50%;
  transform: translateX(-50%);
  width: 360px;
  height: 220px;
  background: radial-gradient(circle, rgba(22, 243, 201, 0.3) 0%, rgba(47, 168, 147, 0.2) 60%, transparent 80%);
}

.glow-middle {
  top: 35%;
  right: -80px;
  width: 260px;
  height: 260px;
  background: radial-gradient(circle, rgba(22, 243, 201, 0.18) 0%, rgba(36, 139, 119, 0.15) 50%, transparent 70%);
}

.glow-bottom {
  bottom: -90px;
  left: 50%;
  transform: translateX(-50%);
  width: 380px;
  height: 220px;
  background: radial-gradient(circle, rgba(22, 243, 201, 0.22) 0%, rgba(24, 107, 90, 0.25) 55%, transparent 75%);
}

/* Credit Scope 标志性动态流线与弧线纹理 (SVG Arcs & Swirls) */
.brand-waves-decor {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 500px;
  margin: 0 auto;
  pointer-events: none;
  z-index: 0;
  opacity: 0.25;
  background-image: 
    radial-gradient(circle at 10% 15%, rgba(22, 243, 201, 0.3) 0%, transparent 8px),
    radial-gradient(circle at 88% 28%, rgba(22, 243, 201, 0.35) 0%, transparent 6px),
    radial-gradient(circle at 18% 75%, rgba(22, 243, 201, 0.25) 0%, transparent 10px),
    radial-gradient(circle at 82% 85%, rgba(22, 243, 201, 0.3) 0%, transparent 7px),
    repeating-linear-gradient(135deg, rgba(22, 243, 201, 0.04) 0px, rgba(22, 243, 201, 0.04) 2px, transparent 2px, transparent 60px);
}

/* 发光同心光环弧线 */
.brand-ambient-rings {
  position: fixed;
  top: -80px;
  right: -80px;
  width: 320px;
  height: 320px;
  border-radius: 50%;
  border: 1.5px dashed rgba(22, 243, 201, 0.15);
  pointer-events: none;
  z-index: 0;

  &::before {
    content: '';
    position: absolute;
    top: 30px;
    left: 30px;
    right: 30px;
    bottom: 30px;
    border-radius: 50%;
    border: 1px solid rgba(22, 243, 201, 0.12);
  }
}

.app-main-content {
  position: relative;
  z-index: 1;
}
</style>
